import React from 'react'
import styled from 'styled-components'
import { Icon } from "@iconify/react";
import { BOTONES } from '../constantes/enums.ts';
import { Linea } from './Linea.jsx';
import { useNavigate } from 'react-router-dom';

const Ficha = ({ texto, color, icono, tipo, titulo, navegar }) => {
    const navigate = useNavigate()
    return (
        <Container onClick={() => navigate(navegar)} tipo={tipo} color={color}>
            {titulo &&
                <>
                    <Titulo>{titulo}</Titulo>
                    <Linea color='white' />
                    <br />
                </>
            }
            <Texto >{texto}</Texto>
            <Circulo color={color}>
                <Icon icon={icono} style={{ fontSize: '36px' }} />
            </Circulo>
        </Container >
    )
}

const Container = styled.button`
    margin-bottom: 50px;
    position: relative;
    padding: 10px;
    color: #fff;
    width: ${props => props.tipo === BOTONES.BOTON ? '70vw' : 'max(30vw, 200px)'};
    height: ${props => props.tipo === BOTONES.BOTON ? '70px' : '200px'} ;
    transition: all .5s ease-in;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 10px #000;
    border-radius: 20px;
    cursor: pointer;
    background-color: ${props => props.color === 'primario' ? `var(--primary)` : `var(--secundary)`};
    & h1{
        font-size: 1rem;
    }
    &:hover{
        scale: 1.05
    }
`

const Titulo = styled.span`
    font-size: 20px;
`

const Texto = styled.span`
    margin-bottom: 10px;
`

const Circulo = styled.div`
    position: absolute;
    bottom:0;
    height: 50px;
    width: 50px;
    border-radius: 50%;
    border: 1px solid black;
    box-shadow: 0 -4px 10px #eee;
    transform: translateY(50%);
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${props => props.color === 'primario' ? `var(--primary)` : `var(--secundary)`};
    padding: 5px;
`


export default Ficha